module.exports = __webpack_public_path__ + "static/media/BG.bd1d86de.png";